import { useForm } from 'react-hook-form'
import moment from 'moment/moment';

import Modal from '../Modal';
import { bulkCreateTaskProject, createTaskProject } from "../../api/project.api";
import { showSuccess, showError } from "../../services/toastServices";
import { CategoryData } from "../../pages/Category/CategoryWrapper";
import { taskSizesStringToEnum } from '../../services/EnumsService';

export function BulkTaskModal({ project, closeAction }) {
    const { register, handleSubmit, formState: { errors }, setValue, control } = useForm();
    const {category, refreshProjectsCategory} = CategoryData();


    const handleClose = () => {
        closeAction()
    };

    const actionBar = (
        <div className="flex">
            <button className=' bg-blue-400 rounded-md block w-10 hover:bg-blue-500' onClick={handleClose}>X</button>
        </div>
    )
    const renderHeader = () => {
        return(<h1 className='font-bold text-2xl'>{project.name} - Agregar una tarea</h1>)
    }  

    const handleSave = handleSubmit(async data => {
        if(project && project.id){
            const tasks = data.tasksList.split(';')
            const taskObjects = []
            tasks.map(task =>(
                taskObjects.push(
                    {
                        name:task.split(',')[0].trim(),
                        size: taskSizesStringToEnum(task.split(',')[1].trim()).value
                    })
            ))
            const payload = {
                projectTaskItems: taskObjects,
            }
    
            await bulkCreateTaskProject(project.id, payload, createTaskSuccess, createTaskError)
        }
    })

    const createTaskSuccess = (res => {
        showSuccess('Tarea creada')
        refreshProjectsCategory(category)
        handleClose()
    })

    const createTaskError = (error => {
        showError(`Error al crear la tarea. ${error.message}. ${error.response.data}`)
    })

    const renderButton = () => {
        return(<button className='bg-blue-400 p-3 rounded-lg block w-full hover:bg-blue-500' onClick={handleSave}>Crear</button>)
    }

    const modal = <Modal onClose={handleClose} actionBar={actionBar} header={renderHeader} modalSize={'52'}>
        <div className='mt-3 grid grid-cols-3 '>
            <div className='col-span-3 ml-2'>
                <form action="" >
                    <div className="flex flex-col">
                    <div className='mb-2'>
                        Listado de tareas separado por ';' en formato nombre,tamaño (XS,S,M,L,XL)
                    </div>
                    <textarea
                        rows="3"
                        placeholder="Lista de tareas"
                        {...register("tasksList", { required: true })}
                        className=' bg-blue-100 p-3 rounded-lg block w-full mb-3 h-64'
                    />
                    {errors.taskList && <span>Campo requerido</span>}
                    </div>
                </form>
                {renderButton()}
            </div>
        </div>
    </Modal>

    return (
        <div>
            {modal}
        </div>
    )
}